import * as types from './types'

export default {
  [types.CHANGE_MESSAGE]: ({ commit }, payload) => {
    commit(types.MUTATE_MESSAGE, payload)
  }
}
